import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-lg text-primary-950">
                <i className="ri-closed-captioning-line"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                最近中文字幕
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              专注提供最新影视作品及中文字幕更新信息的资讯平台，涵盖电影与电视剧两大类别，
              帮助中文影视爱好者快速找到带中文字幕的精彩内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50">
              <a href="/#site-content" className="hover:text-accent-300">
                快速导航
              </a>
            </h4>
            <ul className="mt-4 space-y-2 text-sm text-background-200">
              <li>
                <Link to="/" className="hover:text-accent-300">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/movie" className="hover:text-accent-300">
                  电影专区
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="hover:text-accent-300">
                  电视剧专区
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-accent-300">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50">
              <a href="/about" className="hover:text-accent-300">
                联系与反馈
              </a>
            </h4>
            <ul className="mt-4 space-y-2 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                feedback@zysub-example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                字幕更新：每日 09:00 / 21:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line"></i>
                仅提供信息展示服务
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-700 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 最近中文字幕 · 本站为演示性质影视信息平台</p>
          <p>站内影视名称、简介均为虚构演示内容，不提供真实播放下载服务</p>
        </div>
      </div>
    </footer>
  );
}